import BaseApi from './BaseApi'

class TokensApi extends BaseApi {
  get tokensUrl () {
    return 'tokens'
  }

  verifyToken (token) {
    return this.postJson(this.tokensUrl + '/email/' + token)
  }

  verifyResetToken (token) {
    return this.getJson(this.tokensUrl + '/password-reset/' + token)
  }
}
export default TokensApi

